/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
window.addEventListener("load", () => {
    $ = jQuery;
    if (typeof gsap !== 'undefined') {
        let mm = gsap.matchMedia();
        let movingPercent;
        mm.add("(min-width: 1200px)", () => {
            movingPercent = 30;
        });

        mm.add("(max-width: 1199px)", () => {
            movingPercent = 15;
        });

        $(".slide-down").each(function (i, x) {
            let tl = gsap
                .timeline()
                .from(x, { yPercent: -movingPercent, ease: "none" });

            ScrollTrigger.create({
                trigger: x,
                // start: 'top bottom',
                end: "bottom top",
                scrub: 1,
                animation: tl,
                // markers:true
                invalidateOnRefresh: true,
            });
        });

        $(".slide-up").each(function (i, x) {
            let tl = gsap.timeline().from(x, { yPercent: movingPercent, ease: "none" });

            ScrollTrigger.create({
                trigger: x,
                // start: 'top bottom',
                end: "bottom top",
                scrub: 1,
                animation: tl,
                // markers:true
                invalidateOnRefresh: true,
            });
        });
    }
});
/* eslint-enable no-console */
